import React from 'react';
import { Container } from 'rebass';

export default props => <Container px="5%" {...props} />;
